import React from "react";
import { FaAppStore, FaGooglePlay } from "react-icons/fa";
import { Globe } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 sm:py-28 bg-[#F8FAFC] relative">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight text-slate-900 mb-6">
            Ready to Experience Hassle-Free Maintenance?
          </h2>

          <p className="text-lg md:text-xl text-slate-600 mb-12 font-medium leading-relaxed max-w-2xl mx-auto">
            Join thousands of drivers who trust Americar to keep their vehicles running smoothly and securely.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            {/* App Store Button */}
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="https://apps.apple.com/in/app/americar-ride-track/id6759800657"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-full sm:w-auto gap-3 bg-slate-900 text-white px-8 py-3.5 rounded-xl font-semibold shadow-md transition-all hover:bg-slate-800"
            >
              <FaAppStore className="w-6 h-6" />
              <div className="text-left leading-tight">
                <span className="block text-[10px] text-slate-300 uppercase font-bold">Download on the</span>
                <span className="block text-base font-bold">App Store</span>
              </div>
            </motion.a>

            {/* Google Play Button */}
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="https://play.google.com/store/apps/details?id=americar.app.android"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-full sm:w-auto gap-3 bg-slate-900 text-white px-8 py-3.5 rounded-xl font-semibold shadow-md transition-all hover:bg-slate-800"
            >
              <FaGooglePlay className="w-5 h-5" />
              <div className="text-left leading-tight">
                <span className="block text-[10px] text-slate-300 uppercase font-bold">Get it on</span>
                <span className="block text-base font-bold">Google Play</span>
              </div>
            </motion.a>

            {/* Web App Button */}
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate("/login")}
              className="flex items-center justify-center w-full sm:w-auto gap-3 bg-primary text-white px-8 py-3.5 rounded-xl font-semibold shadow-md transition-all hover:bg-blue-600"
            >
              <Globe className="w-6 h-6" />
              <div className="text-left leading-tight">
                <span className="block text-[10px] text-blue-100 uppercase font-bold">Start using the</span>
                <span className="block text-base font-bold">Web Version</span>
              </div>
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
